// @ts-nocheck
/* eslint-enable */
import cx from 'classnames';
import React, { Fragment, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { textOverflow } from 'app/shared/styles/_mixins';
import 'app/shared/modules/filter/AllFiltersDropdown/style.scss';
import AppActions from 'app/shared/flux/actions/AppActions';
import { filterUtils_getNumberOfActiveFilters } from 'app/shared/utils/filterUtils';
import IconFilter from 'images/icons/filter.svg';
import Text from 'app/shared/core/Text';
import constants from 'app/shared/constants/ValueConstants';
import { useYieldCallback } from '@zillow/yield-callback';

const StyledButton = styled.button`
  ${textOverflow};
`;
const AllFiltersDropdown = () => {
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.filter);
  const screenWidthForDesktopSRPFilter = useSelector((state) => state.app.device.screenWidthForDesktopSRPFilter);
  const showFilterModal = useSelector((state) => state.app.showFilterModal);
  const isExcludingMoreFilters = screenWidthForDesktopSRPFilter === 'xl';

  const isOpen = showFilterModal === 'AllFiltersDropdown';

  let excludeFilters = [];
  if (isExcludingMoreFilters) {
    excludeFilters = [].concat(excludeFilters, ['price', 'bedrooms', 'pets', 'bathrooms']);
  }

  const numSetFilters = filterUtils_getNumberOfActiveFilters(filter, excludeFilters);

  const yieldSetAppStoreBool = useYieldCallback((bool) => {
    dispatch(AppActions.setAppStoreBool('showFilterModal', bool));
  });
  const handleClickToggle = useCallback(() => {
    if (showFilterModal && showFilterModal !== 'AllFiltersDropdown') {
      yieldSetAppStoreBool(false);
      yieldSetAppStoreBool('AllFiltersDropdown');
    } else if (!showFilterModal && showFilterModal !== 'AllFiltersDropdown') {
      yieldSetAppStoreBool('AllFiltersDropdown');
    } else {
      yieldSetAppStoreBool(false);
    }
  }, [dispatch, showFilterModal]);

  const handleKeyDown = useCallback(
    ({ key, altKey }) => {
      if (
        key === constants.ESC_KEYCODE ||
        key === constants.ENTER_KEYCODE ||
        key === constants.SPACE_KEYCODE ||
        (key === constants.DOWN_ARROW_KEYCODE && altKey)
      ) {
        handleClickToggle();
      }
    },
    [handleClickToggle],
  );

  return (
    <StyledButton
      className={cx('AllFiltersDropdown', {
        'AllFiltersDropdown-teal': numSetFilters > 0,
        active: isOpen,
      })}
      onKeyDown={handleKeyDown}
      onClick={handleClickToggle}
      aria-expanded={isOpen}
    >
      {numSetFilters > 0 ? (
        <Fragment>
          <span className="AllFiltersDropdown-num-filters">{numSetFilters}</span>{' '}
          <Text size="sm" className="AllFiltersDropdown-filter-text">
            All filters
          </Text>
        </Fragment>
      ) : (
        <Fragment>
          <img alt="" src={IconFilter} height="15" width="15" fetchpriority="low" decoding="async" />{' '}
          <Text size="sm" className="AllFiltersDropdown-filter-text">
            All filters
          </Text>
        </Fragment>
      )}
    </StyledButton>
  );
};

export default AllFiltersDropdown;
